import { QTag, QTagProps } from "@qualio/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReviewStatus } from "@design-controls/types";

type Props = {
  status: ReviewStatus;
};

export const ReviewStatusTag: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation();
  const variantColor: Record<ReviewStatus, QTagProps["variantColor"]> = {
    [ReviewStatus.enum.IN_PROGRESS]: "gray",
    [ReviewStatus.enum.SENT_FOR_APPROVAL]: "blue",
    [ReviewStatus.enum.APPROVED]: "green",
    [ReviewStatus.enum.NOT_APPROVED]: "red",
  };

  const label: Record<ReviewStatus, string> = {
    [ReviewStatus.enum.IN_PROGRESS]: t("statuses.review.draft"),
    [ReviewStatus.enum.SENT_FOR_APPROVAL]: t("statuses.review.forApproval"),
    [ReviewStatus.enum.APPROVED]: t("statuses.review.approved"),
    [ReviewStatus.enum.NOT_APPROVED]: t("statuses.review.declined"),
  };

  return <QTag variantColor={variantColor[status]}>{label[status]}</QTag>;
};

ReviewStatusTag.displayName = "QTag";
